import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { StorageService } from '../../../services/commons/storage.service';
import { GlobalVariablesService } from '../../../services/global-variables.service';
import { TranslateConfigService } from '../../../services/commons/translate-config.service';
import { NavigationService } from '../../../services/commons/navigation.service';
import { DefaultModalComponent } from '../default-modal/default-modal.component';
import { GlobalMethodsService } from '../../../services/global-methods.service';
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper";
import { CardNew } from '../../../models/CardNew';
SwiperCore.use([Autoplay, Pagination, Navigation]);

@Component({
  selector: 'app-news-presentation',
  templateUrl: './news-presentation.component.html',
  styleUrls: ['./news-presentation.component.scss'],
})
export class NewsPresentationComponent implements OnInit {

  public newsForm: FormGroup;
  public user: string;
  public isServiceBusy = false;
  public swiper: SwiperCore;
  public listCardsNews: CardNew [] = []; 
  @Input('cardsNews') cardsNews: CardNew[];
  @Input('screen') screen: string;

  constructor(private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private storage: StorageService,
    public gvs: GlobalVariablesService,
    private translate: TranslateConfigService,
    public gms: GlobalMethodsService) { }

  async ngOnInit() {
    this.newsForm = this.formBuilder.group({
      checkNotShow: new FormControl(false)
    });
    this.user = this.gvs.user.userName;
    this.listCardsNews = await this.storage.getObject(this.gvs.CARDS_NEWS);
  }

  ionViewWillEnter(){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Presentacion Novedades', contentGroup: 'HOME'}); 
  }

  ionViewDidEnter(){
    this.swiper = new SwiperCore('.swiper-container', {
      // Optional parameters
      direction: 'horizontal',
      speed: 0,
      loop: false,
      effect: 'slide',
      fadeEffect: {
        crossFade: true
      },
      pagination:{
        el: '.swiper-pagination',
        clickable: true
      }
    });
    this.swiper.init();
  }

  async onSubmit() {
    if (this.isServiceBusy){
      return;
    }
      this.isServiceBusy = true;
      await this.gms.setLoadingTrue();
      const checkInternet = await this.gms.checkInternet();
      if(checkInternet){
        if(this.listCardsNews != null && this.cardsNews != null){
          if(this.newsForm.controls.checkNotShow.value){
            for(let i=0; i<this.listCardsNews.length; i++){
              if(this.cardsNews.find(x => x.id_card === this.listCardsNews[i].id_card) != null){
                this.listCardsNews[i].visible = false;
              }
            }
            if(this.listCardsNews.find(x => x.visible === true) == null){
              this.gms.setStatusNewsPanel(false);
            }
          }
        }
        await this.storage.setObject(this.gvs.CARDS_NEWS, this.listCardsNews);
        this.dismiss(true);
      }else{
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
      this.isServiceBusy = false;
      this.gms.setLoadingFalse();
  }

  dismiss(value) {
    this.modalCtrl.dismiss({ result: value });
  }

}
